import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const downloadLatestConsolidatedBid = createAsyncThunk(
  'bid-analysis/downloadLatestConsolidatedBid',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/bid-analysis/download-latest-consolidated-file',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

export const getFilters = createAsyncThunk(
  'bid-analysis/get-filters',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/bid-analysis/get-filters', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getAwardScenarioData = createAsyncThunk(
  'award-scenario/get-award-scenario-list',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/award-scenario/get-award-scenario-list', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const bookmarkScenarioData = createAsyncThunk(
  'award-scenario/bookmark-scenario',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/award-scenario/bookmark-scenario', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getIncumbentSuppliers = createAsyncThunk(
  'bid-analysis/get-incumbent-supplier',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/bid-analysis/get-incumbent-supplier', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getSavingAnalysisKpi = createAsyncThunk(
  'bid-analysis/saving-analysis',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/bid-analysis/saving-analysis', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getSupplierAnalysisKpi = createAsyncThunk(
  'bid-analysis/get-supplier-analysis-details-kpi',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/bid-analysis/get-supplier-analysis-details-kpi',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

export const getPartAnalysisKpi = createAsyncThunk(
  'bid-analysis/v1/bid-analysis/part-analysis-kpi',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/bid-analysis/part-analysis-kpi', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getPartAnalysisCategoriesKpi = createAsyncThunk(
  'bid-analysis/v1/bid-analysis/category-analysis-kpi',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/bid-analysis/category-analysis-kpi', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getRankData = createAsyncThunk(
  'bid-analysis/v1/bid-analysis/award-scenario/get-rank-wise-dropdown',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/award-scenario/get-rank-wise-dropdown', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
export const markFavoriteSupplier = createAsyncThunk(
  'bid-analysis/v1/bid-analysis/mark-favorite-supplier',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/bid-analysis/mark-favorite-supplier', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getSupplierData = createAsyncThunk(
  'bid-analysis/v1/bid-analysis/award-scenario/get-supplier-dropdown-for-award-filters',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/award-scenario/get-supplier-dropdown-for-award-filters',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

export const getBidAnalysisProjectScenario = createAsyncThunk(
  'bid-analysis/v1/bid-analysis/get-bid-analysis-projects-scenario',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      '/v1/bid-analysis/get-bid-analysis-projects-scenario',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
        isRejectWithErrorMsg: true,
      },
    )
  },
)

export const deleteAwardScenario = createAsyncThunk(
  'award-scenario/delete-award-scenario',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/award-scenario/delete-scenario', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
 

export const duplicateAwardScenario = createAsyncThunk(
  'award-scenario/create-duplicate-award-scenario',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/award-scenario/create-duplicate-award-scenario', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getRankDropdownData = createAsyncThunk(
  'bid-analysis/v1/award-scenario/get-rank-saving-dropdown',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/award-scenario/get-rank-saving-dropdown', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const addScenarioByRank = createAsyncThunk(
  'bid-analysis/v1/award-scenario/save-award-scenario-by-rank',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/award-scenario/save-award-scenario-by-rank', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)
